import React, { useState, useEffect, useMemo } from "react";
import { Helmet } from "react-helmet";
import { currentDomain, currentPath } from "../Index";
import { usePromotionsData } from "../data/PromotionData";
import { useNavigate } from "react-router-dom";
import useAppPromotionTheme from "../hooks/useAppPromotionTheme";

export default function FrostFireClash({ isLightMode }) {
	const isAppPromo = useAppPromotionTheme(isLightMode);
	const { promotionsData, isPromotionDataReady } = usePromotionsData();
	const data = useMemo(
		() =>
			promotionsData.find(
				(promo) => promo.title === "Fastspin Frostfire Clash",
			),
		[promotionsData],
	);
	const [isMobile, setIsMobile] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 841);
		};
		handleResize();
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	// If the promo page is expired - throws error
	useEffect(() => {
		if (!isPromotionDataReady) return;

		if (!data) {
			navigate("/not-found");
		}
	}, [isPromotionDataReady, data, navigate]);

	if (!isPromotionDataReady || !data) return null;

	return (
		<>
			<Helmet>
				<meta charSet="utf-8" />
				<title> Fastspin Frostfire Clash </title>
				<link rel="icon" href="/images/fav.webp" sizes="32x32" />
				<link rel="canonical" href={`${currentDomain}${currentPath}`} />
			</Helmet>
			<div className="promotion-page-main all-page-main-container-min-height">
				<div className="promotion-page-container main-container-global-adjusted-padding">
					<div className="promotion-tnc-page">
						<div className="promotion-page-breadcrumb">
							<a
								href={
									isAppPromo
										? "/promotion/".replace("/promotion", "/app-promotion")
										: "/promotion/"
								}
							>
								Promotions
							</a>{" "}
							/ <span> {data.title} </span>
						</div>
						<div className="promotion-tnc-banner">
							<img
								src={isMobile ? data.imgSrc : data.bannerSrc}
								alt={`FGH${data.title}`}
							/>
							<div className="promotion-tnc-content">
								<div className="promotion-tnc-info">
									<div
										className={`promotion-indication-message ${data.promotionMessage.class}`}
									>
										{data.promotionMessage.text}
									</div>
									<h1> FastSpin Frostfire Clash </h1>
									<h2> Total Prize: ₱5,599,275</h2>
									<div className="promotion-tnc-period">
										<strong> Event Period: </strong>
										<span> August 17 (12PM) - Nov 30 (11:59AM), 2026 </span>
									</div>
								</div>
								<div className="promotion-tnc-mechanic-content">
									<strong> Campaign Details </strong>
									<ol>
										<li>
											If a player appears on more than one leaderboard, the
											player will be able to win more than one prize. The prize
											will be remitted in 72 hours after each tournament round
											ends, please check changes in the player' s wallet
											balance.
										</li>
										<li>
											Players will be able to check their rank, rules, and terms
											through the{" "}
											<strong className="highlight">"Tournament"</strong> icon
											available in games.
										</li>
										<li>
											If there are two or more players with identical win
											scores, the player who scores it first will get a higher
											position on the leaderboard.
										</li>
										<li>
											Fastspin reserves the right to disqualify a player or
											group of players if being found to use dishonest methods,
											cheat or intimidate other players/operators, or found to
											be abusing system loopholes to affect the result.
										</li>
										<li>
											Fastspin reserves the right to modify the activity terms
											and conditions without prior notice.
										</li>
									</ol>
									<div className="table-wrapper">
										<table
											className="promotion-tnc-table"
											style={{ minWidth: "0" }}
										>
											<thead>
												<th>Quantity</th>
												<th>Prize</th>
											</thead>
											<tbody>
												<tr>
													<td>1</td>
													<td>₱123,400</td>
												</tr>
												<tr>
													<td>2</td>
													<td>₱61,700</td>
												</tr>
												<tr>
													<td>3</td>
													<td>₱24,680</td>
												</tr>
												<tr>
													<td>4-10</td>
													<td>₱6,170</td>
												</tr>
												<tr>
													<td>11-40</td>
													<td>₱3,085</td>
												</tr>
												<tr>
													<td>41-70</td>
													<td>₱617</td>
												</tr>
												<tr>
													<td>71-100</td>
													<td>₱308.5</td>
												</tr>
											</tbody>
										</table>
									</div>

									<div className="promotion-tnc-cta">
										<a
											className="promotion-cta-btn"
											href="https://fastspinpromotion.com/2026_Aug_Nov_Tournament/"
											target="_blank"
											rel="noreferrer"
										>
											View Full T&C
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
